<template lang="html">
  <div class="create-dynamic"
    :style="{ height: isAndroid ? 'calc(100vh - 50px)' : `calc(100vh - ${50 + safeHeight}px)` }">
    <!-- <h3>发动态</h3> -->
    <Card v-model="loading" :active="active">
      <div class="menus">
        <button class="cancel" @click="cancel">取消</button>
        <button :class="visible_range === 'common' ? 'primary' : 'oversea_primary'" @click="submit">发表</button>
      </div>
    </Card>
    <!-- <textarea ref="textarea" class="content" v-model="content" autofocus :placeholder="placeholder"></textarea> -->
    <div id="textarea" ref="textarea" class="content" contenteditable="true" :placeholder="placeholder" autofocus
      @keyup="handkeKeyUp" @keydown="handleKeyDown"></div>
    <div class="tags" v-if="!getCircleId">
      <div class="tag-box">
        <div class="tag-item" style="padding-right: 8px; border-color: #333;">
          <span @click="showAddTag = true"># 打标签</span>
        </div>
        <span class="tag-item" v-for="(tag, index) of checkedTags" :key="`${tag.id}`">
          <span class="tag-desc" @click="checkedTag(`${tag.id}`)"># {{ tag.title }}</span>
          <img @click.stop="removeTag(index)" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/tag-close.svg" />
        </span>
      </div>
    </div>
    <div class="operations" v-if="!getCircleId">
      <div v-if="!active" class="operations1">
        <!-- 上传改版 start-->
        <button class="Media-button" @click="upBtn">
          <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/image.svg" />
          <span v-if="platform !== 'notInDingTalk'">
            上传媒体
            <input @change="uploadFile" ref="upvideo" style="display: none;" class="uploadFile" accept="image/*,video/*"
              type="file" />
          </span>
          <span v-else>
            上传媒体
          </span>
          <div v-if="platform === 'notInDingTalk'" v-show="showMediaClassFly" class="ClassFly">
            <div @click="startImage" class="cell">
              <div>图片</div>
              <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/image.svg" />
              <input @change="uploadFile" ref="upimage" style="display: none;" class="uploadFile" accept="image/*"
                type="file" />
            </div>
            <div @click="startCamera" class="cell">
              <div>拍照</div>
              <img src="https://exerlalnd.oss-cn-shanghai.aliyuncs.com/exerland-wechat/resource/image/camera.svg" />
              <input @change="uploadFile" type="file" ref="camera" style="display: none;" accept="image/*"
                capture="camera">
            </div>
            <div @click="startVideo" class="cell">
              <div>视频</div>
              <img src="https://exerlalnd.oss-cn-shanghai.aliyuncs.com/exerland-wechat/resource/image/video.svg" />
              <input @change="uploadFile" ref="upvideo" style="display: none;" accept="video/*" type="file" />
            </div>
            <div v-if="visible_range==='oversea'" @click="startPdf" class="cell">
              <div>文档</div>
              <img src="https://exerlalnd.oss-cn-shanghai.aliyuncs.com/exerland-wechat/resource/image/video.svg" />
              <input @change="uploadFile" ref="upText" style="display: none;" accept="application/pdf" type="file" />
            </div>
          </div>
        </button>
        <!-- 上传改版 end-->
        <button class="link-button" @click="active = 'link'">
          <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/link.svg" />
          <span>插入链接</span>
        </button>
      </div>
      <div v-else-if="active === 'link'" class="link">
        <div
          :class="{ contents: true, linkWidthShow: active === 'link', linkWidthHidden: active !== 'link' && active !== null }"
          :style="{ width: active === 'link' ? '100%' : '165px' }">
          <img class="links" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/link.svg" />
          <input v-model="link" placeholder="请输入以 http 或 https 开头" />
          <div class="close" @click="active = ''">
            <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/close-white.svg" />
          </div>
        </div>
      </div>
    </div>
    <div class="img-box" v-if="active === 'imgs' && !getCircleId">
      <UploadImg v-for="(item, index) of imgs" :class="{ img: true, square: Object.is(imgs.length, 4) }"
        v-model="item.url" :key="item.sort" @removeImg="removeImg(index)" @uploadStart="uploadStart(item)"
        @uploadSuccess="uploadSuccess(item)" />
    </div>
    <div class="img-box" v-if="active === 'video' && !getCircleId">
      <UploadImg :video=true v-for="(item, index) of imgs" :class="{ img: true, square: Object.is(imgs.length, 4) }"
        v-model="upVideodata.firstFrame" :key="item.sort" @removeImg="removeImg(index)" @uploadStart="uploadStart(item)"
        @uploadSuccess="uploadSuccess(item)" />
    </div>
    <div class="pdf_box" v-if="active === 'pdf'">
      <PDFthumbnail :DelIcon=true class="pdf_item" @removeImg = "removeImg" @uploadFile="uploadFile" v-for="(item,index) of imgs" :index="index" :total=item :key="item.sort" />
    </div>
    <Message v-if="showMessage" @closeModel="closeModel" :label="messageLabel" />
    <SetNickName :show="showSetNickName" @close="showSetNickName = false" />
    <add-tag v-model="showAddTag" :oldTags="checkedTags" @checked="checkedTagFn" />
    <van-cell-group class="address-cell" v-if="visible_range === 'common'">
      <van-cell center :title="!getCircleId ? '匿名发表' : '匿名评论'" label="开启后发表此条内容将不对外展示昵称和头像">
        <template #right-icon>
          <van-switch @change="changeActual" v-model="is_actual" size='30px' active-color="#18CC9F"
            inactive-color="#dcdee0" />
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group class="address-cell" v-if="user.isAllowHiddenPost">
      <van-cell center title="是否展示" label="开启后动态将展示给所有人">
        <template #right-icon>
          <van-switch @change="changeIsHidden" v-model="is_hidden" size='30px' active-color="#18CC9F"
            inactive-color="#dcdee0" />
        </template>
      </van-cell>
    </van-cell-group>
    <van-overlay class="upVideoloading_box" :show="upVideoShow">
      <!-- <van-loading v-if="active === 'video'" style="margin-top: 60%;" type="spinner" color="#0094ff" size="24px" vertical>资源上传中...</van-loading> -->
      <div class="upVideoloading">
        <van-circle v-model="currentRate" :rate="rate" :stroke-width="100" :text="upSchedule()" />
        <div>文件上传中...</div>
      </div>
    </van-overlay>
    <!-- @用户弹出 -->
    <!-- 自定义图标 -->
    <van-popup class="reminderBox" v-model="showDialog" closeable close-icon="close" position="bottom"
      :style="{ height: '50%' }">
      <div class="top">
        <div class="title">选择要@的人</div>
        <input ref="queryString" class="queryString" type="text" v-model="queryString" placeholder="搜索名字">
      </div>
      <div class="bottom">
        <van-list :finished="finished" finished-text="没有更多了">
          <van-cell v-for="item in userList" :key="item.id">
            <div class="cell" @click="handlePickUser(item)">
              <van-image round width="34px" height="34px" :src="item.avatar">
                <template v-slot:error>{{
                  UserInfoName(item.fullname) || ""
                }}</template>
              </van-image>
              <div class="name">{{ item.fullname }}</div>
            </div>
          </van-cell>
        </van-list>
      </div>
    </van-popup>
  </div>
</template>
<script>
import axios from 'axios'
import { post, putFile } from '../../../utils/request.js'
import { get as getUser } from '../../../utils/token'
import { isAndroid, compressImage } from '../../../utils/utils'
// import oss from '../../../utils/upLoadOSS'
import Message from '../../../components/message'
import AuthMixis from '../../../minixs/auth'
import Card from '../../../components/CardLoading'
import UploadImg from '../../../components/uploadImage'
import AddTag from '../../../components/addTags'
import { Toast } from 'vant'
import dd from 'DD'
import { videoExamine, messageInform, getUsersByName } from '../../../api/api'
import PDFthumbnail from '../../../components/PDFthumbnail.vue'
export default {
  mixins: [AuthMixis],
  components: {
    UploadImg,
    Message,
    Card,
    [AddTag.name]: AddTag,
    PDFthumbnail
  },
  data () {
    return {
      uploader: '',
      finished: true,
      node: '', // 获取到节点
      userList: '', // 选中项的内容
      endIndex: '', // 光标最后停留位置
      queryString: '', // 搜索值
      showDialog: false, // 是否显示弹窗
      currentRate: 0,
      rate: 10,
      upVideodata: {
        onProgress: 0,
        videoUrl: '',
        screen_style: '',
        firstFrame: ''
      },
      uid: null,
      platform: dd.env.platform,
      upVideoShow: false,
      content: '',
      imgs: [
        {
          sort: 1,
          loading: false,
          url: ''
        }
      ],
      showAddTag: false,
      isAndroid: isAndroid(),
      safeHeight: 0,
      placeholder: '这一刻的想法…',
      showMessage: false,
      messageLabel: '不能为空',
      // tags: [],
      checkedTags: [],
      tagId: 'all',
      loading: false,
      link: '',
      videoUrl: '',
      showMediaClassFly: false, // 用于显示选择媒体分类
      active: null, // 激活 null不激活，link 填写链接， imgs: 上传图片，video上传视频
      is_actual: false, // 发帖是否隐藏： is_actual  true ->正常显示头像   false  -> 匿名头像
      is_hidden: true, // 发帖是否显示在动态中
      // imgIoading: false
      user: getUser('user'),
      pid: this.$route.query.pid,
      visible_range: this.$route.query.visible_range,
      SelectUsers: []
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      const query = vm.$route.query
      let title = ''
      if (query.circleId) {
        title = '写留言'
      } else {
        title = '发动态'
      }
      if (query.curriculumId && !query.circleId) {
        title = '请留言'
      }
      if (dd.env.platform !== 'notInDingTalk') {
        dd.ready(function () {
          dd.biz.navigation.setTitle({
            title: title
          })
        })
      }
      document.title = title
    })
  },
  mounted () {
    const query = this.$route.query
    if (query.circleId || query.curriculumId) {
      this.placeholder = '回复'
    }
    if (!query.curriculumId && !query.circleId) {
      // this.getTags()
    }
    if (query.curriculumId && !query.circleId) {
      this.placeholder = '请写下你的看法'
    }
    if (query.parentNickName) {
      this.placeholder = `回复${query.parentNickName}：`
    }
    if (query.parentNickName) {
      this.placeholder = `回复${query.parentNickName}：`
    }
    this.preinstallTag()
  },
  methods: {
    createUploader (type) {
      const self = this
      const uploader = new window.AliyunUpload.Vod({
        timeout: 60000,
        partSize: Math.round(1048576),
        parallel: 5,
        retryCount: 3,
        retryDuration: 2,
        region: 'cn-shanghai',
        userId: '1763563789506146',
        localCheckpoint: true, // 此参数是禁用服务端缓存，不影响断点续传
        // 开始上传
        onUploadstarted: function (uploadInfo) {
          // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
          // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
          // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
          // 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
          // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
          // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)
          if (!uploadInfo.videoId) {
            const createUrl = `https://circle.fosun.com/api/v1/circle/aliyun/vod/CreateUploadVideo?title=${uploadInfo.file.name}`
            axios.get(createUrl).then(({ data: { data } }) => {
              const uploadAuth = data.UploadAuth
              const uploadAddress = data.UploadAddress
              const videoId = data.VideoId
              uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId)
            })
            self.statusText = '文件开始上传...'
            // console.log('onUploadStarted:' + uploadInfo.file.name + ', endpoint:' + uploadInfo.endpoint + ', bucket:' + uploadInfo.bucket + ', object:' + uploadInfo.object)
          } else {
            // 如果videoId有值，根据videoId刷新上传凭证
            // https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
            const refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
            axios.get(refreshUrl).then(({ data }) => {
              const uploadAuth = data.UploadAuth
              const uploadAddress = data.UploadAddress
              const videoId = data.VideoId
              uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId)
            })
          }
        },
        // 文件上传成功
        onUploadSucceed: function (uploadInfo) {
          // console.log('onUploadSucceed: ' + uploadInfo.file.name + ', endpoint:' + uploadInfo.endpoint + ', bucket:' + uploadInfo.bucket + ', object:' + uploadInfo.object)
          // console.log('------------------------------')
          self.upVideodata.videoUrl = `https://cdns.focuth.com/${uploadInfo.object}`
          // console.log(`https://cdns.focuth.com/${uploadInfo.object}`)
          // console.log('------------------------------')
        },
        // 文件上传失败
        onUploadFailed: function (uploadInfo, code, message) {
          // console.log('onUploadFailed: file:' + uploadInfo.file.name + ',code:' + code + ', message:' + message)
        },
        // 取消文件上传
        onUploadCanceled: function (uploadInfo, code, message) {
          // console.log('Canceled file: ' + uploadInfo.file.name + ', code: ' + code + ', message:' + message)
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function (uploadInfo, totalSize, progress) {
          // console.log('onUploadProgress:file:' + uploadInfo.file.name + ', fileSize:' + totalSize + ', percent:' + Math.ceil(progress * 100) + '%')
          const progressPercent = Math.ceil(progress * 100)
          self.upVideodata.onProgress = progressPercent
          // self.upvideodata.onProgress = progressPercent
        },
        // 上传凭证超时
        onUploadTokenExpired: function (uploadInfo) {
          // 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
          // 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)重新获取 UploadAuth
          // 然后调用 resumeUploadWithAuth 方法, 这里是测试接口, 所以我直接获取了 UploadAuth
          const refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
          axios.get(refreshUrl).then(({ data }) => {
            const uploadAuth = data.UploadAuth
            uploader.resumeUploadWithAuth(uploadAuth)
            // console.log('upload expired and resume upload with uploadauth ' + uploadAuth)
          })
        },
        // 全部文件上传结束
        onUploadEnd: function (uploadInfo) {
          // console.log('onUploadEnd: uploaded all the files')
        }
      })
      return uploader
    },
    // 处理没有头像情况
    UserInfoName (name) {
      return name.substr(-1, 1)
    },
    async getUserList () {
      this.finished = false
      const data = {
        mobile: this.user.phoneNumber,
        key: this.queryString
      }
      const { data: res } = await getUsersByName(data)
      this.userList = res
      this.finished = true
    },
    // 获取光标位置
    getCursorIndex () {
      const selection = window.getSelection()
      return selection.focusOffset // 选择开始处 focusNode 的偏移量
    },
    // 获取节点
    getRangeNode () {
      const selection = window.getSelection()
      return selection.focusNode // 选择的结束节点
    },
    // 弹窗出现的位置
    getRangeRect () {
      const selection = window.getSelection()
      const range = selection.getRangeAt(0) // 是用于管理选择范围的通用对象
      const rect = range.getClientRects()[0] // 择一些文本并将获得所选文本的范围
      const LINE_HEIGHT = 30
      return {
        x: rect.x,
        y: rect.y + LINE_HEIGHT
      }
    },
    // 是否展示 @
    showAt () {
      const node = this.getRangeNode()
      if (!node || node.nodeType !== Node.TEXT_NODE) return false
      const content = node.textContent || ''
      const regx = /@([^@\s]*)$/
      const match = regx.exec(content.slice(0, this.getCursorIndex()))
      if (!match) return false
      return match[0] !== '@' ? false : match && match.length === 2
    },
    // 获取 @ 用户
    getAtUser () {
      const content = this.getRangeNode().textContent || ''
      const regx = /@([^@\s]*)$/
      const match = regx.exec(content.slice(0, this.getCursorIndex()))
      if (match && match.length === 2) {
        return match[1]
      }
      return undefined
    },
    // 创建标签
    createAtButton (user) {
      const btn = document.createElement('span')
      // btn.style.display = 'inline-block'
      // btn.dataset.user = JSON.stringify(user)
      btn.className = 'AtSpan'
      btn.contentEditable = 'false'
      btn.textContent = `@${user.fullname}`
      // const wrapper = document.createElement('span')
      // wrapper.style.display = 'inline-block'
      // wrapper.style.margin = '0 5px'
      // wrapper.contentEditable = 'false'
      // const spaceElem = document.createElement('span')
      // spaceElem.style.whiteSpace = 'pre'
      // spaceElem.textContent = '\u200b'
      // spaceElem.contentEditable = 'false'
      // const clonedSpaceElem = spaceElem.cloneNode(true)
      // wrapper.appendChild(spaceElem)
      // wrapper.appendChild(btn)
      // wrapper.appendChild(clonedSpaceElem)
      return btn
    },
    replaceString (raw, replacer) {
      return raw.replace(/@([^@\s]*)$/, replacer)
    },
    // 插入@标签
    replaceAtUser (user) {
      const node = this.node
      if (node && user) {
        const content = node.textContent || ''
        const endIndex = this.endIndex
        const preSlice = this.replaceString(content.slice(0, endIndex), '')
        const restSlice = content.slice(endIndex)
        const parentNode = node.parentNode
        const nextNode = node.nextSibling
        const previousTextNode = new Text(preSlice)
        const nextTextNode = new Text('\u200b' + restSlice) // 添加 0 宽字符
        const atButton = this.createAtButton(user)
        parentNode.removeChild(node)
        // 插在文本框中
        if (nextNode) {
          parentNode.insertBefore(previousTextNode, nextNode)
          parentNode.insertBefore(atButton, nextNode)
          parentNode.insertBefore(nextTextNode, nextNode)
        } else {
          parentNode.appendChild(previousTextNode)
          parentNode.appendChild(atButton)
          parentNode.appendChild(nextTextNode)
        }
        // 重置光标的位置
        const range = new Range()
        const selection = window.getSelection()
        range.setStart(nextTextNode, 0)
        range.setEnd(nextTextNode, 0)
        selection.removeAllRanges()
        selection.addRange(range)
      }
    },
    // 键盘抬起事件
    handkeKeyUp () {
      if (this.showAt()) {
        const node = this.getRangeNode()
        const endIndex = this.getCursorIndex()
        this.node = node
        this.endIndex = endIndex
        this.position = this.getRangeRect()
        // this.queryString = this.getAtUser() || ''
        this.showDialog = true
      } else {
        this.showDialog = false
      }
    },
    // 键盘按下事件
    handleKeyDown (e) {
      if (this.showDialog) {
        if (e.code === 'ArrowUp' ||
          e.code === 'ArrowDown' ||
          e.code === 'Enter') {
          e.preventDefault()
        }
      }
    },
    // 插入标签后隐藏选择框
    handlePickUser (user) {
      this.replaceAtUser(user)
      this.userList = user
      this.$refs.queryString.blur()
      this.showDialog = false
      this.queryString = ''
    },
    // 隐藏选择框
    handleHide () {
      this.showDialog = false
    },
    // 显示选择框
    handleShow () {
      this.showDialog = true
    },
    upBtn () {
      if (this.platform === 'notInDingTalk') {
        this.showMediaClassFly = !this.showMediaClassFly
      } else {
        this.startVideo()
      }
    },
    upSchedule () {
      return this.rate.toFixed(0) + '%'
    },
    // // 上传文件处理
    // uploadFileNew (e) {
    //   console.log(e.target.files[0])
    // },
    //
    startPdf () {
      this.$refs.upText.click()
    },
    // 启动视频文件
    startVideo () {
      this.$refs.upvideo.click()
    },
    // 启动图片文件
    startImage () {
      this.$refs.upimage.click()
    },
    // 启动相机
    startCamera () {
      this.$refs.camera.click()
    },
    preinstallTag () {
      // 查看是否携带默认标签数据跳转
      const id = this.$route.params.id
      const title = this.$route.params.title
      if (id && title) {
        // console.log('添加')
        const obj = {
          id,
          title,
          tagCount: 1
        }
        this.checkedTags.push(obj)
      }
    },
    checkedTagFn (tags) {
      this.checkedTags = tags
    },
    // 新增匿名代码 start
    changeActual () {
      const isActual = this.is_actual
      let message = '已开启匿名发表'
      if (isActual) {
        message = '已开启匿名发表'
      } else {
        message = '已关闭匿名发表'
      }
      Toast({
        message: message,
        position: 'top'
      })
    },
    // 新增匿名代码 end
    changeIsHidden () {
      const isHidden = this.is_hidden
      let message = '动态展示'
      if (!isHidden) {
        message = '动态不展示'
      }
      Toast({
        message: message,
        position: 'top'
      })
    },
    // getTags () {
    //   const promise = get({
    //     url: '/circle/tag'
    //   })
    //   promise.then(res => {
    //     const {
    //       data: { code, detail }
    //     } = res
    //     if (Object.is(code, 200)) {
    //       this.tags = detail
    //     }
    //   })
    // },
    checkedTag (tagId) {
      this.tagId = tagId
    },
    autoTextarea (elem, extra, maxHeight) {
      extra = extra || 0
      const isFirefox =
        !!document.getBoxObjectFor || 'mozInnerScreenX' in window
      const isOpera =
        !!window.opera && !!window.opera.toString().indexOf('Opera')
      const addEvent = function (type, callback) {
        elem.addEventListener
          ? elem.addEventListener(type, callback, false)
          : elem.attachEvent('on' + type, callback)
      }
      const getStyle = elem.currentStyle
        ? function (name) {
          const val = elem.currentStyle[name]

          if (name === 'height' && val.search(/px/i) !== 1) {
            const rect = elem.getBoundingClientRect()
            return (
              rect.bottom -
              rect.top -
              parseFloat(getStyle('paddingTop')) -
              parseFloat(getStyle('paddingBottom')) +
              'px'
            )
          }

          return val
        }
        : function (name) {
          return getComputedStyle(elem, null)[name]
        }
      const minHeight = parseFloat(getStyle('height'))

      elem.style.resize = 'none'

      const change = function () {
        let scrollTop
        let height
        let padding = 0
        const style = elem.style

        if (elem._length === elem.value.length) return
        elem._length = elem.value.length

        if (!isFirefox && !isOpera) {
          padding =
            parseInt(getStyle('paddingTop')) +
            parseInt(getStyle('paddingBottom'))
        }
        scrollTop =
          document.body.scrollTop || document.documentElement.scrollTop

        elem.style.height = minHeight + 'px'
        if (elem.scrollHeight > minHeight) {
          if (maxHeight && elem.scrollHeight > maxHeight) {
            height = maxHeight - padding
            style.overflowY = 'auto'
          } else {
            height = elem.scrollHeight - padding
            style.overflowY = 'hidden'
          }
          style.height = height + extra + 'px'
          scrollTop += parseInt(style.height) - elem.currHeight
          document.body.scrollTop = scrollTop
          document.documentElement.scrollTop = scrollTop
          elem.currHeight = parseInt(style.height)
        }
      }

      addEvent('propertychange', change)
      addEvent('input', change)
      addEvent('focus', change)
      change()
    },
    closeModel () {
      this.showMessage = false
      this.messageLabel = ''
    },
    checkoutSensitiveWords () {
      const { content } = this
      const words = [/郭广昌/, /汪群斌/, /陈启宇/, /徐晓亮/]
      let label = null
      try {
        words.forEach(item => {
          label = item.exec(content)
          if (label) {
            throw new Error(label)
          }
        })
      } catch (e) {
        /* eslint-disable-next-line */
        console.log("e", e);
      }
      return label
    },
    cancel () {
      if (this.judgeIsUploadImages) {
        Toast.fail('请等待图片上传完成！')
        return
      }
      this.$router.back()
    },
    // 内容节点标签分析
    contenTagAnalyse (NodeList) {
      for (let i = 0; i < NodeList.length; i++) {
        const item = NodeList[i]
        if (item.nodeName === '#text') {
          this.content += item.nodeValue
        } else if (item.nodeName === 'DIV') {
          if (i === 0) {
            this.content += item.innerText
          } else {
            this.content += `</br>${item.innerText}`
          }
        } else
        if (item.nodeName === 'SPAN') {
          // if (item.innerHTML.indexOf('data-user') !== -1) {
          //   console.log(item)
          //   this.content += `${item.innerText}`
          // } else {
          //   this.content += item.innerText
          // }
          this.content += item.outerHTML
        } else if (item.innerText.trim() === '') {
          this.content += '</br>'
        } else {
          this.content += item.innerText
        }
      }
      // NodeList.forEach(item => {
      //   // const a = document.createElement('a')
      //   // a.innerHTML = item.innerHTML
      //   // if (a.childNodes.length > 0) {
      //   //   this.contenTagAnalyse(a.childNodes)
      //   // }
      //   if (item.nodeName === '#text') {
      //     this.content += item.nodeValue
      //   } else
      //   if (item.nodeName === 'SPAN') {
      //     if (item.innerHTML.indexOf('data-user') !== -1) {
      //       this.content += `<span class='AtSpan'>${item.innerText}</span>`
      //     } else {
      //       this.content += item.innerText
      //     }
      //   } else if (item.innerText.trim() === '') {
      //     this.content += '</br>'
      //   } else {
      //     this.content += item.innerText
      //   }
      // })
    },
    // 提交时进行@用户判断 重写content内容
    async submit () {
      /* eslint-disable-next-line */
      // const vConsole = new window.VConsole()
      const contentNodeList = this.$refs.textarea.childNodes
      // alert(JSON.stringify(contentNodeList))
      this.contenTagAnalyse(contentNodeList)
      // contentNodeList.forEach(item => {
      //   if (item.nodeName === '#text') {
      //     this.content += item.nodeValue
      //   } else
      //   if (item.nodeName === 'SPAN') {
      //     if (item.innerHTML.indexOf('data-user') !== -1) {
      //       console.log(item.childNodes)
      //       this.content += `<span class='AtSpan'>${item.innerText}</span>`
      //     } else {
      //       this.content += item.innerText
      //     }
      //   } else if (item.innerText.trim() === '') {
      //     this.content += '</br>'
      //   } else {
      //     this.content += item.innerText
      //   }
      // })
      // console.log(this.content)
      // if (this.content) return
      // 详情数据同步
      if (this.$route.query.circleId) {
        this.$bus.$emit('UPDynamicDetail', this.$route.query.circleId)
        this.$bus.$emit('UPDynamicListDetail', this.$route.query.circleId)
      }
      if (this.judgeIsUploadImages) {
        Toast.fail('请等待图片上传完成！')
        return
      }
      // const label = this.checkoutSensitiveWords()
      // if (label) {
      //   this.showMessage = true
      //   this.messageLabel = `不许出现${label}字段`
      //   return
      // }
      const flag = await this.judgeUserNickName()
      if (flag) {
        return
      }
      const query = this.$route.query
      if (query.parentNickName) {
        delete query.parentNickName
      }
      if (!this.content) {
        Toast.fail('亲，写点内容在发表吧～')
        return
      }
      if (query.curriculumId && !query.circleId) {
        // 专辑一级评论
        await this.submitCurriculumMessage()
      } else {
        if (query.circleId) {
          await this.submitComment()
        } else {
          // 发表评论
          await this.submitCircle()
        }
      }
    },
    submitCurriculumMessage () {
      this.loading = true
      const { content } = this
      const query = this.$route.query
      const data = {
        content: content.replace(/\n/g, '<br/>'),
        userId: this.user.id,
        curriculumId: query.curriculumId,
        visible_range: this.visible_range
      }
      if (query.imgUrl) {
        data.imgUrl = query.imgUrl
      }
      const promise = post({
        url: '/course/comment',
        data
      })
      promise.then(res => {
        const {
          data: { code }
        } = res
        if (Object.is(code, 200)) {
          this.loading = false
          this.$router.back()
        }
      })
    },
    submitCircle () {
      const _this = this
      this.loading = true
      const { content, user, imgs, checkedTags, active, uid, visible_range: visibleRange } = _this
      // const circleId = this.getCircleId
      const data = {
        visible_range: _this.visible_range,
        uid,
        content: content.replace(/\n/g, '<br/>'),
        tags: checkedTags,
        userId: _this.user.id,
        // 新增匿名代码 start
        is_actual: !_this.is_actual, // 发表增加是否匿名参数
        // 新增匿名代码 end
        is_hidden: !_this.is_hidden
      }
      if (active === 'link') {
        data.link = _this.link
      }
      if (active === 'imgs' || active === 'pdf') {
        data.images = imgs
      }
      if (active === 'video') {
        data.images = [{
          sort: 1,
          url: _this.upVideodata.videoUrl
        }]
        data.screen_style = _this.upVideodata.screen_style
      }
      const promise = post({
        url: '/circle/circle',
        data,
        timeout: 25000
      })
      promise.then(res => {
        const {
          data: { code },
          data: { detail }
        } = res
        if (Object.is(code, 200)) {
          if (visibleRange === 'oversea') {
            messageInform({
              circle_id: detail.id,
              action_type: 5,
              operator_mobile: user.username,
              is_anonymous: false,
              comment_id: null
            })
          }
          videoExamine({
            uid: _this.uid,
            url: _this.upVideodata.videoUrl
          })
          _this.loading = false
          if (active === 'video') {
            _this.$notify('视频动态已发布！后台审核通过后予以展示')
          }
          if (_this.visible_range === 'common') {
            _this.$router.replace({
              name: 'Dynamic',
              params: { ispublish: true }
            })
          } else {
            _this.$router.replace({
              name: 'OverseasDetail',
              params: { ispublish: true }
            })
          }
        }
      }).catch(err => {
        Toast.fail('动态上传失败', JSON.stringify(err))
        // alert(JSON.stringify(err))
      }).finally(() => {
        _this.loading = false
      })
    },
    removeTag (index) {
      this.checkedTags.splice(index, 1)
    },
    submitComment () {
      this.loading = true
      const { content, user, visible_range: visibleRange } = this
      const circleId = this.getCircleId
      const mobile = this.$route.query.mobile
      const query = this.$route.query
      const isAnonymous = !this.$route.query.isAnonymous
      const promise = post({
        url: '/circle/comment',
        data: {
          content: content.replace(/\n/g, '<br/>'),
          userId: this.user.id,
          // 新增匿名代码 start
          is_actual: !this.is_actual, // 发表增加是否匿名参数
          // 新增匿名代码 end
          ...query
        }
      })
      promise.then(res => {
        const {
          data: { code }
        } = res
        if (Object.is(code, 200)) {
          const actionType = visibleRange === 'common' ? 1 : 6
          this.loading = false
          if (this.pid) {
            messageInform({
              circle_id: circleId,
              action_type: actionType,
              mobile,
              operator_mobile: user.username,
              is_anonymous: this.placeholder.indexOf('匿名用户') !== -1,
              comment_id: this.pid
            })
          } else {
            messageInform({
              circle_id: circleId,
              action_type: actionType,
              mobile: mobile,
              operator_mobile: user.username,
              is_anonymous: visibleRange === 'common' ? isAnonymous : false,
              comment_id: null
            })
          }
          setTimeout(() => {
            this.$router.back()
          }, 500)
        }
      })
    },
    removeImg (index) {
      this.imgs.splice(index, 1)
      if (this.active === 'video') {
        this.imgs = [
          {
            sort: 1,
            loading: false,
            url: ''
          }
        ]
      }
      this.uploadSuccess()
    },
    uploadStart (item) {
      item.loading = true
    },
    uploadSuccess (item) {
      if (this.active === 'video') {
        this.uid = ''
        this.active = null
        this.upVideodata = {
          onProgress: 0,
          videoUrl: '',
          screen_style: '',
          firstFrame: ''
        }
        return
      }
      if (item) {
        item.loading = false
      }
      const { imgs } = this
      // 此处用于修正图片的序号
      imgs.forEach((item, index) => {
        item.sort = index + 1
      })
      if (imgs.length > 8) {
        return
      }
      const filter = imgs.filter(item => !item.url)
      if (filter.length) {
        return
      }
      imgs.push({
        sort: imgs.length + 1,
        loading: false,
        url: ''
      })
      this.active = 'imgs'
    },
    // 判断已上传视频是否宽屏,并且获取当前视频的第一帧
    // 其中移动端需让其先播放之后再进行截取，否则会导致截取的图片为空白
    isVideoVandscape (files) {
      const that = this
      const videoUrl = URL.createObjectURL(files)
      const videoObj = document.createElement('video')
      videoObj.volume = 0
      videoObj.autoplay = true
      videoObj.loop = 'loop'
      videoObj.src = videoUrl
      videoObj.onloadeddata = function (evt) {
        // URL.revokeObjectURL(videoUrl)
        const { videoWidth, videoHeight } = videoObj
        const canvas = document.createElement('canvas')
        canvas.width = videoWidth
        canvas.height = videoHeight
        canvas.getContext('2d').drawImage(videoObj, 0, 0, videoWidth, videoHeight)
        that.upVideodata.firstFrame = canvas.toDataURL('image/png')
        if (videoWidth > videoHeight) {
          that.upVideodata.screen_style = 'landscape'
        } else {
          that.upVideodata.screen_style = 'vertical'
        }
        videoObj.pause()
        videoObj.remove()
        canvas.remove()
      }
      // videoObj.load()
    },
    // 视频上传成功处理
    upVideoOk () {
      this.upVideoShow = false
      const img = {
        sort: 1,
        url: this.upVideodata.videoUrl
      }
      this.imgs = [img]
      this.active = 'video'
      Toast.success('视频已上传')
      // Toast.success(JSON.stringify(this.upVideodata.firstFrame))
      // Toast.success(JSON.stringify(this.imgs))
    },
    async uploadFile (e) {
      this.upVideoShow = true
      this.showMediaClassFly = false
      // this.imgIoading = true
      if (!e.target.files[0]) {
        this.upVideoShow = false
        return
      }
      if (e.target.files[0].type.split('/')[1] === 'pdf') {
        const { imgs } = this
        const img = {
          name: e.target.files[0].name,
          sort: imgs.length + 1,
          url: ''
        }
        imgs.unshift(img)
        const promise = putFile({
          url: '/bbs/uploadFile',
          file: e.target.files[0]
        })
        promise.then(res => {
          const {
            status,
            data: { detail }
          } = res
          if (Object.is(status, 200)) {
            let url = detail[0]
            if (url.indexOf('https') === -1) {
              url = url.replace('http', 'https')
            }
            img.url = url
            this.active = 'pdf'
            this.uid = null
            this.upVideoShow = false
          }
        })
      } else if (e.target.files[0].type.split('/')[0] === 'video') {
        try {
          // 获取上传的视频的宽高
          const userData = '{"Vod":{}}'
          this.isVideoVandscape(e.target.files[0])
          // console.log(e.target.files[0])
          this.uploader = await this.createUploader(e.target.files[0])
          await this.uploader.addFile(e.target.files[0], null, null, null, userData)
          await this.uploader.startUpload()
          // const res = await oss.ossUploadFile(e.target, this.upVideodata)
          // if (this.upVideodata.firstFrame === '') {
          //   this.upVideodata.firstFrame = `https://exerlalnd.oss-cn-shanghai.aliyuncs.com/${res.fileUrl}?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto`
          // }

          // this.upVideodata.videoUrl = `https://exerlalnd.oss-cn-shanghai.aliyuncs.com/${res.fileUrl}`
          // this.uid = uuid().replace(/-/g, '') // 生成UUID
        } catch (error) {
          // console.log(error)
          this.upVideoShow = false
          Toast.fail('视频上传失败')
        }
      } else {
        const { imgs } = this
        const img = {
          sort: imgs.length + 1,
          url: ''
        }
        imgs.unshift(img)
        const imgFile = await compressImage(e.target.files[0], 0.8)
        const promise = putFile({
          url: '/bbs/uploadFile',
          file: imgFile
        })
        promise.then(res => {
          const {
            status,
            data: { detail }
          } = res
          if (Object.is(status, 200)) {
            let url = detail[0]
            if (url.indexOf('https') === -1) {
              url = url.replace('http', 'https')
            }
            img.url = url
            this.active = 'imgs'
            this.uid = null
            this.upVideoShow = false
          }
          if (Object.is(status, 205)) {
            this.messageLabel = '图片违规！'
            this.upVideoShow = false
            this.showMessage = true
            imgs.shift()
          }
          // this.imgIoading = false
        })
      }
    }
  },
  computed: {
    getCircleId () {
      return this.$route.query.circleId || this.$route.query.curriculumId
    },
    judgeIsUploadImages () {
      const { imgs } = this
      const some = imgs.some(item => item.loading)
      return some
    },
    getStyle () {
      const style = {}
      const { active } = this
      if (active === 'link') {
        style.animation = 'widthShow 5s alternate'
      } else if (active === 'img') {
        style.animation = 'widthHIdden 5s alternate'
      }
      return style
    },
    getImageLength () {
      return this.imgs.length
    }
  },
  watch: {
    queryString () {
      this.getUserList()
    },
    showDialog () {
      if (this.showDialog) {
        this.queryString = ''
        this.getUserList()
        this.$nextTick(() => {
          this.$refs.queryString.focus()
        })
      }
    },
    // reminderShow (flag) {
    //   if (!flag) {
    //     // this.$refs.textarea.focus()
    //     const range = window.getSelection()
    //     this.$nextTick(() => {
    //       range.selectAllChildren(this.$refs.textarea)
    //       range.collapseToEnd()
    //     })
    //   }
    // },
    // content (newValue, oldValue) {
    //   if (newValue.length > oldValue.length) {
    //     if (newValue.substr(-1) === '@') {
    //       this.reminderShow = true
    //       this.$nextTick(() => {
    //         this.$refs.queryString.focus()
    //       })
    //     }
    //   }
    // },
    getImageLength (value) {
      if (value === 1) {
        this.active = null
      }
    },
    upVideodata: {
      deep: true,
      handler () {
        this.rate = this.upVideodata.onProgress
        if (this.upVideodata.onProgress === 100) {
          this.upVideoOk()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
// start
/deep/ .van-circle__text {
  color: #fff;
}

/deep/ .AtSpan {
  margin: 0 5px;
  color: #000000;
}

.reminderBox {
  position: absolute;
  text-align: center;
  padding-top: 10px;

  .top {
    height: 70px;
    width: 100%;
  }

  .bottom {
    height: 250px;
    overflow: scroll;
  }

  .cell {
    display: flex;
    padding-left: 20px;

    .name {
      margin-left: 20px;
      font-size: 16px;
    }
  }

  .title {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .queryString {
    border-radius: 10px;
    border: none;
    height: 30px;
    width: 80%;
    background-color: #f3f3f3;
    padding-left: 15px;
  }
}

.Media-button {
  position: relative;

  // .imgIoading{
  //   position: absolute;
  // }
  .ClassFly {
    position: absolute;
    border-radius: 10px;
    width: calc(100% + 20px);
    top: 49px;
    left: 0px;
    z-index: 9999;
    height: auto;
    background-color: #f5f5f5;

    .cell {
      display: flex;
      position: relative;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #fff;

      & img {
        width: auto;
        height: auto;
        max-height: 100%;
        max-width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }

      & div {
        display: inline-block;
        margin-left: 17px;
      }
    }

    &>.cell:last-child {
      border-bottom: none;
    }
  }
}

.address-cell {
  .van-cell__value {
    min-width: 20%;

    span {
      display: inline-block;
      text-align: left;
      word-break: break-all;
    }
  }

  .van-cell__title {
    min-width: 80%;
  }
}

// end
@keyframes widthLinkShow {
  from {
    left: 100%;
  }

  to {
    left: 0;
  }
}

@keyframes widthLinkHIdden {
  from {
    left: 0;
  }

  to {
    left: 100%;
  }
}

@keyframes buttonShow {
  from {
    right: 100%;
  }

  to {
    right: 0;
  }
}

@keyframes buttonHIdden {
  from {
    right: 0;
  }

  to {
    right: 100%;
  }
}

@keyframes LinkWidthShow {
  from {
    width: 165px;
  }

  to {
    width: 100%;
  }
}

@keyframes LinkWidthHidden {
  from {
    width: 100%;
  }

  to {
    width: 165px;
  }
}
.upVideoloading_box {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  // .upVideoloading {
  //   text-align: center;
  // }
}

.create-dynamic {
  height: 100vh;
  background: #fff;

  h3 {
    font-size: 17px;
    font-family: SFProText-Semibold, SFProText;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    line-height: 22px;
    text-align: center;
    padding: 13px 4.27vw;
  }

  .menus {
    box-sizing: border-box;
    padding: 8px 0;
    display: flex;
    justify-content: space-between;
    width: 95.46vw;
    margin: 0 auto;
    background: #fff;

    .oversea_primary {
      width: 75px;
      height: 35px;
      background: #0A93E3;
      border-radius: 17.5px;
      font-size: 15px;
      font-weight: 500;
      color: #FFFFFF;
    }

    button {
      font-size: 17px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      line-height: 24px;
      border-radius: 4px;
      width: 56px;
      height: 32px;
      box-sizing: border-box;
      text-align: center;
      display: inline-block;
      background: #fff;
      border: none;
    }

    .primary {
      color: #fff;
      background: #18cc9f;
    }
  }

  .content {
    -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
    box-sizing: border-box;
    width: 100%;
    padding: 0 16px;
    border: none;
    outline: none;
    margin-bottom: 16px;
    font-size: 17px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 24px;
    min-height: 72px;
    margin-top: 32px;
    max-height: 200px !important;
    overflow: scroll !important;

    &::-webkit-input-placeholder {
      color: rgba(204, 204, 204, 1);
    }
  }

  .content:empty::before {
    content: attr(placeholder);
    color: rgba(204, 204, 204, 1);
  }

  .pdf_box {
    max-height: 440px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5px; /* 可根据需要调整间距 */
    // padding: 0 5px;
    overflow-x: auto;
    place-items: center;
  }
  .pdf_box .pdf_item:last-child:nth-child(odd) {
    grid-column-start: 1;
  }
  .img-box {
    padding-left: 16px;

    /deep/ .img-item {
      margin-right: 5px;
    }

    .square:nth-child(2n) {
      margin-right: 30%;
    }

    .square:nth-child(2n + 1) {
      margin-right: 1.33vw !important;
    }

    .last {
      position: relative;
    }

    .img:nth-child(3n) {
      margin-right: 0;
    }
  }

  .tags {
    margin: 27px 16px 0 16px;

    h4 {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(136, 136, 136, 1);
      line-height: 20px;
    }

    .tag-box {
      margin-top: 13px;

      .active {
        color: #18cc9f;
        background: #ecfdf9;
      }
    }
  }

  .operations {
    width: 100%;
    // overflow: hidden;
    width: 100%;
    white-space: nowrap;
    position: relative;

    .operations1 {
      box-sizing: border-box;
      width: 100%;
      padding: 12px 16px 16px 16px;
      display: inline-block;
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 9;

      /deep/ .class {
        margin-right: 12px;
      }

      .class {
        width: calc(50% - 7px);
        border-radius: 8px;
      }

      button {
        width: calc(50% - 7px);
        border: none;
        height: 49px;
        background: #f5f5f5;
        border-radius: 8px;
        outline: none;
        padding: 0 32px 0 21px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 21px;
          height: 17px;
          display: inline-block;
          margin-right: 23px;
        }

        span {
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 21px;
        }
      }
    }

    .link {
      width: 100%;
      padding: 16px;
      box-sizing: border-box;
      display: flex;
      justify-content: flex-end;

      .contents {
        width: 165px;
        box-sizing: border-box;
        padding: 14px 16px;
        height: 49px;
        background: #f5f5f5;
        border-radius: 8px;
        display: block;
        display: inline-flex;
        justify-content: flex-end;
        position: relative;

        input {
          background: #f5f5f5;
          padding-left: 15px;
          border: none;
          outline: none;
          width: 100%;
          height: 100%;
        }

        .links {
          width: 18px;
          height: 18px;
        }

        .close {
          position: absolute;
          box-sizing: border-box;
          top: -10px;
          right: -10px;
          width: 21px;
          height: 21px;
          background: #000000;
          border: 0px solid #ffffff;
          border-radius: 50%;
          padding: 5px;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .animationLinkShow {
    animation: widthLinkShow 0.8s alternate;
  }

  .animationLinkHidden {
    animation: widthLinkHIdden 0.8s alternate;
  }

  .animationButtonShow {
    animation: buttonShow 0.8s alternate;
  }

  .animationButtonHidden {
    animation: buttonHIdden 0.8s alternate;
  }

  .linkWidthShow {
    animation: LinkWidthShow 0.8s alternate;
  }

  .linkWidthHidden {
    animation: LinkWidthHidden 0.8s alternate;
  }
}

.tag-item {
  display: inline-flex;
  // justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333;
  background: rgba(245, 245, 245, 1);
  border-radius: 4px;
  margin-right: 12px;
  border-radius: 16px;
  border: 1px solid #cccccc;
  padding: 6px 12px;
  box-sizing: border-box;
  margin-bottom: 8px;
  background: #fff;

  .tag-desc {
    display: inline-block;
    white-space: nowrap;
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  img {
    width: 10px;
    height: 10px;
    display: inline-block;
    margin-left: 8px;
  }
}</style>
